import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useBaseURL } from '../../context/BaseURLContext';
import { getBrandLogoSvg } from '../../branding/brandings';

const VALIDATOR_BASE_URL = process.env.REACT_APP_VALIDATOR_BASE_URL;
const logoSrc = getBrandLogoSvg();

export const ErrorPage = () => {
    const baseURL = useBaseURL();
    const { t } = useTranslation();
    const { state } = useLocation();
    const navigate = useNavigate();

    const onNavigateBack = () => {
        document.body.classList.remove('template-error');
        navigate(-1);
    }

    useEffect(() => {
        document.body.classList.add('template-error');
    }, []);

    return (
        <div className="component-error">

            {state && (<div className="errorPage">
                <img src={logoSrc} className="img-fluid" alt={t('navbar.logo')} />

                <div className="errorPage__text">
                    <h2 className="error__type"> {state.code ? state.code : ''} </h2>
                    <h3 className="error__title"> {state.title ? state.title : ''} </h3>
                    <p className="error__detail"> {state.detailFirst ? state.detailFirst : ''} <br /> {state.detailSecond ? state.detailSecond : ''} </p>
                    <button onClick={onNavigateBack} className="btn-medium btn-primary"> {t('error.go-back')} </button>
                    <NavLink to={baseURL.includes(VALIDATOR_BASE_URL) ? '/validator' : '/'} className="base-link"> {t('error.go-home')} </NavLink>
                </div>
            </div>)}

        </div>
    )
}